import React from "react";
import "swiper/css/bundle";
import SwiperCore from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { AiFillHeart, AiOutlineHeart } from "react-icons/ai";
import { addToWishlist } from "../redux/actions/wishListActon";

SwiperCore.use([Navigation, Pagination, Autoplay]);

function RelatedProducts() {
  const { product } = useSelector((state) => state.product);
  const wishlist = useSelector(
    (state) => state?.auth?.wishlist?.wishlist || [],
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleAddToWishlist = (productId) => {
    dispatch(addToWishlist(productId, navigate, 1));
  };

  return (
    <div>
      <style>{`
        .sc-card {
          background: #fff;
          position: relative;
          overflow: hidden;
          border-radius: 16px;
          border: 1px solid #f0f0f0;
          box-shadow: 0 2px 8px rgba(0,0,0,0.04);
          transition: transform 0.25s ease, box-shadow 0.25s ease;
          height: 100%;
          display: flex;
          flex-direction: column;
        }
        .sc-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 12px 32px rgba(20,184,166,0.12);
        }
        .sc-card__img-wrap {
          position: relative;
          height: 200px;
          overflow: hidden;
          background: #f8fafc;
          border-radius: 16px 16px 0 0;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 10px;
        }
        .sc-card__img {
          width: 100%; height: 100%;
          object-fit: contain;
          display: block;
          transition: transform 0.55s cubic-bezier(.25,.46,.45,.94);
        }
        .sc-card__img--hover {
          position: absolute;
          inset: 0;
          width: 100%; height: 100%;
          object-fit: cover;
          opacity: 0;
          transition: opacity 0.45s ease, transform 0.55s cubic-bezier(.25,.46,.45,.94);
          transform: scale(1.04);
        }
        .sc-card:hover .sc-card__img { transform: scale(1.05); }
        .sc-card:hover .sc-card__img--hover { opacity: 1; transform: scale(1); }

        .sc-card__badge {
          position: absolute;
          top: 10px;
          left: 10px;
          font-size: 9px;
          font-weight: 800;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          padding: 3px 7px;
          border-radius: 1px;
          z-index: 2;
        }
        .sc-card__badge--instock { 
          background: linear-gradient(135deg, #14b8a6, #0d9488); 
          color: #fff; 
          border-radius: 20px;
        }
        .sc-card__badge--out { background: #374151; color: #fff; border-radius: 20px; }

        .sc-card__actions {
          position: absolute;
          bottom: 0; left: 0; right: 0;
          display: flex;
          justify-content: flex-end;
          padding: 8px;
          transform: translateY(110%);
          transition: transform 0.28s cubic-bezier(.4,0,.2,1);
          z-index: 3;
        }
        .sc-card:hover .sc-card__actions { transform: translateY(0); }
        .sc-card__action-btn {
          width: 34px;
          height: 34px;
          border-radius: 50%;
          background: #fff;
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          box-shadow: 0 2px 10px rgba(0,0,0,0.13);
          color: #555;
          transition: background .18s, transform .14s;
          margin-left: 5px;
        }
        .sc-card__action-btn:hover { background: #14b8a6; color: #fff; transform: scale(1.1); }
        .sc-card__action-btn.wished { color: #ef4444; }

        .sc-card__info { padding: 12px 12px 16px; flex-grow: 1; }
        .sc-card__cat {
          font-size: 9px;
          font-weight: 700;
          letter-spacing: 0.13em;
          text-transform: uppercase;
          color: #aaa;
          display: block;
          margin-bottom: 4px;
        }
        .sc-card__title {
          font-size: 13px;
          font-weight: 600;
          color: #1a1a1a;
          line-height: 1.35;
          margin: 0 0 9px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-decoration: none;
          transition: color .18s;
        }
        .sc-card__title:hover { color: #14b8a6; }
        .sc-card__price-wrap { display: flex; align-items: center; gap: 7px; margin-top: 4px; }
        .sc-card__price { font-size: 15px; font-weight: 800; color: #0d9488; }
        .sc-card__old-price { font-size: 12px; color: #bbb; text-decoration: line-through; }
      `}</style>

      <section className="product__section product__section--style3 section--padding pt-0">
        <div className="container product3__section--container">
          <div className="section__heading text-center mb-50">
            <h2 className="section__heading--maintitle">Related Products</h2>
          </div>
          <div className="product__section--inner">
            <Swiper
              spaceBetween={20}
              slidesPerView={4}
              navigation={false}
              loop={product.length > 5}
              autoplay={{
                delay: 3500,
                disableOnInteraction: false,
              }}
              breakpoints={{
                0: { slidesPerView: 2, spaceBetween: 10 },
                480: { slidesPerView: 2, spaceBetween: 15 },
                768: { slidesPerView: 3, spaceBetween: 20 },
                1024: { slidesPerView: 4, spaceBetween: 20 },
                1200: { slidesPerView: 5, spaceBetween: 20 },
              }}
            >
              {product.map((p) => (
                <SwiperSlide key={p._id}>
                  <div className="sc-card">
                    <div className="sc-card__img-wrap">
                      <Link to={`/productdetails/${p._id}`}>
                        <img
                          className="sc-card__img"
                          src={p?.colors?.[0]?.images?.[0]?.secure_url}
                          alt={p.title}
                        />
                        <img
                          className="sc-card__img--hover"
                          src={
                            p?.colors?.[0]?.images?.[1]?.secure_url ||
                            p?.colors?.[0]?.images?.[0]?.secure_url
                          }
                          alt={p.title}
                        />
                      </Link>

                      <span
                        className={`sc-card__badge ${
                          p.quantity > 0
                            ? "sc-card__badge--instock"
                            : "sc-card__badge--out"
                        }`}
                      >
                        {p.quantity > 0 ? "In Stock" : "Out of Stock"}
                      </span>

                      <div className="sc-card__actions">
                        <Link
                          to={`/productdetails/${p._id}`}
                          className="sc-card__action-btn"
                          title="Quick View"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                            <circle cx="12" cy="12" r="3" />
                          </svg>
                        </Link>
                        <button
                          className={`sc-card__action-btn ${
                            wishlist.some((w) => w._id === p._id)
                              ? "wished"
                              : ""
                          }`}
                          onClick={() => handleAddToWishlist(p._id)}
                          title="Wishlist"
                        >
                          {wishlist.some((w) => w._id === p._id) ? (
                            <AiFillHeart size={15} />
                          ) : (
                            <AiOutlineHeart size={15} />
                          )}
                        </button>
                      </div>
                    </div>

                    <div className="sc-card__info">
                      <span className="sc-card__cat">{p.category}</span>
                      <Link
                        to={`/productdetails/${p._id}`}
                        className="sc-card__title"
                      >
                        {p.title}
                      </Link>
                      <div className="sc-card__price-wrap">
                        <span className="sc-card__price">{p.price} ETB</span>
                        {p.oldPrice && (
                          <span className="sc-card__old-price">
                            {p.oldPrice} ETB
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </section>
    </div>
  );
}

export default RelatedProducts;
